import Factory from '../../common/di/factory';

export default (di) => {
	di.setType({type: Factory, name: 'Factory', params: {container: di}});
};
